module.exports = __webpack_public_path__ + "img/snowy-dark.ec2be298.png";